import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { Icon } from '@bshgroup/component-icon';
import { useTokens } from '@bshgroup/component-themes';
import { forwardRef } from 'react';
export const HintContentIcon = forwardRef(({ ...props }, ref) => {
    const tokens = useTokens();
    return (_jsx(Icon, { size: "sm", css: { color: tokens.styles['hint-content-icon-background'] }, ...props, ref: ref }));
});
HintContentIcon.displayName = 'HintContentIcon';
